export default "__VITE_ASSET__Co6Ks8Y$__"